export default "__VITE_ASSET__BEaIxMIj__"